export default () => {
    const videoBg = document.querySelector('.home-hero__bg');
    if (videoBg) {
        window.addEventListener('load', () => {
            const iconRound = document.querySelector('.right-box__icon .round .default.inner');
            if (iconRound) {
                iconRound.style.animationDuration = videoBg.duration + 's';
                iconRound.classList.add('inner--animated')
            }
        })
    }
}
